import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import type { FilterKey, FilterParams } from '@core/Entities/Search/QueryParams.entity';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { createPathFromFilters } from '@core/Utils/Search/CreatePathFromFilters';
import { createQueryStrFromFilters } from '@core/Utils/Search/CreateQueryStrFromFilters';
import { getBasePathFromRoot } from '@core/Utils/Search/GetBasePathFromRoot';

const filtersToPath = (filtersSlug: string[]) => {
  return `/${filtersSlug.join('/')}`;
};

const validateUrl = (
  filtersSlug: string[],
  searchParams: { [key: string]: string | string[] | undefined },
  combinedFilterParams: FilterParams,
  root: PlpRoot = 'used',
) => {
  const basePath = getBasePathFromRoot(root);

  // convert searchParams back into query string
  const searchFilterArray: Filter[] = Object.keys(searchParams)
    .filter(fltrKey => fltrKey !== 'region' && fltrKey !== 'area' && fltrKey !== 'dealership-id') // Exclude 'region', 'area' and 'dealership-id' keys
    .map(fltrKey => ({
      id: fltrKey as FilterKey,
      value: searchParams[fltrKey as FilterKey],
    }));
  const queryString = createQueryStrFromFilters(searchFilterArray);

  //reconstruct the current path
  const receivedPath = `${basePath}${filtersSlug.length > 0 ? filtersToPath(filtersSlug) : ''}${
    queryString ? `?${queryString}` : ''
  }`;

  //build a path with the cleaned & validated filters
  const filterArray: Filter[] = Object.keys(combinedFilterParams).map(fltrKey => ({
    id: fltrKey as FilterKey,
    value: combinedFilterParams[fltrKey as FilterKey],
  }));
  const expectedPath = createPathFromFilters(filterArray, root);

  return {
    isValid: expectedPath === receivedPath,
    alternativePath: expectedPath,
  };
};

export { validateUrl };
